<template>
  <div class="occupancy-block">
    <div class="occupancy-block__wrap">
      <span v-html="'Per'" />
      <div class="occupancy-block__content" v-b-popover.hover.top="block_occupancy.tooltip">
        <div v-if="block_occupancy.adults > 4" class="occupancy-block__adults">
          <vb-icon class="occupancy-block__icon occupancy-block__icon--adults" :name="'user'" :color="'13131a'" :size="16" />
          <sup class="text--sm" v-html="' x' + block_occupancy.adults" />
        </div>
        <div v-else v-for="index_adults in block_occupancy.adults" :key="_uid + '_adults_' + index_adults" class="occupancy-block__adults">
          <vb-icon class="occupancy-block__icon occupancy-block__icon--adults" :name="'user'" :color="'13131a'" :size="16" />
        </div>
        <vb-icon class="occupancy-block__icon"
          v-for="index_child in block_occupancy.children"
          :key="_uid + '_child_' + index_child" :name="'user'" :color="'13131a'" :size="14"
        />
      </div>
      <vb-icon class="occupancy-block__icon occupancy-block__icon--info" :name="'info'" :color="'adb5bd'" :size="13" v-b-popover.hover.top="block_occupancy.tooltip" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'occupancy-block',

  components: {
  },

  props: {
    block: Object,
    occupancy: Array
  },

  data() {
    return {
      block_occupancy: this.get_block_occupancy()
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
    get_block_occupancy() {
      let block = this.block

      // doc analisi: https://docs.google.com/document/d/16F9s-W6VBLhq-enVrzo2Otg8sSOQrMx6vSrataKKTec/edit

      /* todo: serve per fare dei test
      block = {
        block_id : '502149905_170420758_1_1_0',
        max_adults: 5,
        max_children_free_age: 3,
        max_children_free: 2
      }*/

      let occupancy_block = {
        adults: block.max_adults,
        children: 0,
        tooltip: ''
      }

      const max_occupancy = block.max_occupancy
      const max_children_free = block.max_children_free
      const max_children_free_age = block.max_children_free_age
      const max_adults = block.max_adults
      const is_child_block = !block.block_id.endsWith("_0")

      this.occupancy.forEach(pax => {
        pax.children.forEach(age => {

          /* Caso 1
          es: ricerca AA6 (blocco con max_children_free_age > 0)
            {
              max_occupancy: 3,
              max_children_free_age: 11,      // => un bambino fino all’età di 11 anni è gratuito
              max_children_free: 1,           // => stampa icona bambino
              max_adults: 2,                  // => stampa due icone adults
            }
          */
          if (age <= max_children_free_age && max_children_free > 0) {
            occupancy_block.children = max_children_free
            // Eccezione di usabilità: max_children_free > 0 && pax.children.length === 1
            if (pax.children.length === 1) occupancy_block.children = 1
          }

          /* Caso 3
          es: ricerca AA6 (blocco con max_children_free_age == 0)
            {
              max_occupancy: 3,
              max_children_free_age: 0,       // => a prescindere da max_children_free, se NON ho un'età di riferimento in max_children_free_age allora NON stampo icona bambino
              max_children_free: 1,           // => in questo caso è subordinato al max_children_free_age
              max_adults: 2,                  // => stampa due icone adults
            }
          */
          if (max_children_free_age === 0 && max_children_free > 0) occupancy_block.children = 0

          /* Caso 2 (child_block)
          es: ricerca AA6 con 
            {
              max_occupancy: 3,               // =>
              max_children_free_age: -1,      // => 
              max_children_free: 0,           // => 
              max_adults: 2,                  // => stampa due icone adults
            }
            se NON fosse un child_block stamperebbe zero icone bambini, ma essendo un child_block stampa UNA icona bambino
          */
          if(is_child_block && max_children_free_age === -1 && max_children_free === 0) occupancy_block.children = 1

          /* Caso 5 (child_block)
          es: ricerca AA69 con 
            {
              max_occupancy: 4,
              max_children_free_age: 2,       // => 
              max_children_free: 2,           // => 
              max_adults: 0,                  // => 
            }
            se NON fosse un child_block stamperebbe zero icone bambini, ma essendo un child_block stampa n icone bambino (legate alla ricerca, vedi sotto)
          */
          if (is_child_block && max_children_free !== 0) occupancy_block.children = (pax.children.length === 1) ? 1 : max_children_free

          // Se occupancy totale e il max adult sono uguali non devo stampare l'icona bambino
          if(max_occupancy === max_adults) occupancy_block.children = 0
        })
      })

      /* Tooltip  */
      occupancy_block.tooltip = 'Soluzione per ' + block.max_adults + (block.max_adults > 1 ? ' adulti' : ' adulto') +
        (
          occupancy_block.children > 0
          ? ' e ' + occupancy_block.children + (occupancy_block.children > 1 ? ' bambini' : ' bambino') + ' fino a ' +
            block.max_children_free_age + (block.max_children_free_age > 1 ? ' anni' : ' anno')
          : ' o ' + block.max_adults + (block.max_adults > 1 ? ' ospiti' : ' ospite')
        )

      return occupancy_block
    }    
  },
}
</script>

<style lang="scss" scoped>

  .occupancy-block {
    $this_occupancy: &;

    &__wrap {
      display: flex;
      align-items: center;
    }

    &__content {
      display: flex;
      align-items: baseline;
      border-radius: $border-radius-lg;
      padding: 4px 2px;
      background-color: $wild-sand;
      margin-left: 5px;

      sup {
        margin: 10px 2px 0 0;
      }
    }

    &__adults {
      display: flex;
      align-items: center;
    }

    &__icon {
      display: flex;
      align-items: center;

      @at-root #{$this_occupancy}__adults + & {
        position: relative;
        padding-left: 10px;
        margin-left: 3px;

        &:before {
          content: '+';
          position: absolute;
          left: 0;
        }
      }

      &--info {
        margin: 2px 0 0 5px;
      }
    }
  }

</style>